import * as Yup from 'yup';

import { MAX_LENGTH_CHAR_NOTE } from '@/common/constants';

export const reviewInspectorSchema = () => {
    return (
        Yup.object({
            status: Yup.string().required('Status is required'),
            note: Yup.string().when(['status'], {
                is: (status: string) => status == '4',
                then: (schema) => schema.required('Note is required when status is reject').max(MAX_LENGTH_CHAR_NOTE, `Note must be at most ${MAX_LENGTH_CHAR_NOTE} characters`),
                otherwise: (schema) => schema.notRequired().max(MAX_LENGTH_CHAR_NOTE, `Note must be at most ${MAX_LENGTH_CHAR_NOTE} characters`)
            }),
        }))
};
